import styled from '@emotion/styled'
import { css } from '@emotion/react'

type LabelProps = {
  disabled?: boolean
}

export const Wrapper = styled.div<LabelProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: fit-content;
  cursor: pointer;
  user-select: none;

  svg {
    position: relative;
    bottom: 1px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`
